import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  Data,
} from '../../..';

const ArticleCardType = ({
  type,
}) => {
  return (
    <ExtendedBox
      w={1}
      mb={20}
      mt={20}
      px={10}
    >
      <Data
        color="black"
        type="D4"
        m={0}
      >
        {type}
      </Data>
    </ExtendedBox>
  );
};

ArticleCardType.propTypes = {
  type: PropTypes.string,
};

ArticleCardType.defaultProps = {
  type: '',
};

export default ArticleCardType;
